import { URL_BASE } from "../constants";
import { getRequest } from "../requests";

export async function getAllMarketingCampaigns(position, stateCode, cityName) {
    const response = await getRequest(`${URL_BASE}/marketing-campaigns/position/${position}?stateCode=${stateCode}&cityName=${cityName}`);
    return response.data;
}